import { Model } from "./Model";
import { Phone } from "./Phone";
import { Crew } from "./Crew";

export class User extends Model {
  static props = {
    id: { type: Number },
    name: { type: String, required: true },
    last_name: { type: String },
    email: { type: String, required: true },
    type: { type: String, required: true },
    primary_phone: { type: Phone },
    additional_phones: { type: Array },
    crew: { type: Crew }
  };

  constructor(parameters) {
    super(User.props, parameters);
  }

  mapParametersToModel(parameters, props) {
    super.mapParametersToModel(parameters, props);

    if (parameters.additional_phones) {
      this.additional_phones = parameters.additional_phones.map(p => {
        return new Phone(p);
      });
    }
  }
}
